import {
  MapProvider,
  GeolocationInput,
  GeolocationAddress,
} from './map-provider';

export class WazeProvider extends MapProvider {
  name = 'Waze';

  generateUrl(destination: GeolocationInput): string {
    if (typeof destination === 'string') {
      return `${WazeProvider.URL_PREFIX}?q=${encodeURIComponent(destination)}&navigate=yes`;
    }

    if (this.isCoordinates(destination)) {
      return `${WazeProvider.URL_PREFIX}?ll=${destination.latitude}%2C${destination.longitude}&navigate=yes`;
    }

    const address = this.formatAddress(destination);
    return `${WazeProvider.URL_PREFIX}?q=${encodeURIComponent(address)}&navigate=yes`;
  }

  private formatAddress(address: GeolocationAddress): string {
    const parts = [
      address.locationName,
      address.address,
      address.city,
      address.state,
      address.zipCode,
      address.country,
    ].filter((p) => p != null && p !== '');

    return parts.join(', ');
  }

  private static URL_PREFIX = 'https://www.waze.com/ul';
}
